export default __webpack_public_path__ + "static/media/CM_Small_Horizontal_Logo_RGB_Sand.5b5a3dd7.svg";